import { cn } from "@/lib/utils";

type LabelVariant = "descriptive" | "action" | "reinforcement";

interface LabeledBodyProps {
  label: string;
  children: React.ReactNode;
  variant?: LabelVariant;
  className?: string;
}

const variantStyles: Record<LabelVariant, string> = {
  descriptive: "text-muted-foreground",
  action: "text-primary",
  reinforcement: "text-success",
};

export function LabeledBody({
  label,
  children,
  variant = "descriptive",
  className,
}: LabeledBodyProps) {
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <span
        className={cn(
          "text-xs font-bold uppercase tracking-wider",
          variantStyles[variant]
        )}
      >
        {label}
      </span>
      <div className="text-sm leading-relaxed text-foreground">{children}</div>
    </div>
  );
}
